import React, { useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import serviceData from "../Data/ServiceData";
import Hero from "../Components/Hero";

function ServiceDetail() {
  const { title } = useParams();
  const location = useLocation();
  const guide = serviceData.find((service) => service.slug === title) || serviceData[0];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <div className="contact_container">
        <Hero link="Loan Guides" pageName={guide.title} />
      </div>
      <main className="service_detail_container guide_article_page">
        <div className="scontainer">
          <div className="row">
            <article className="col-lg-9">
              <div className="guide_article">
                <img
                  className="guide_article_image"
                  src={guide.bigImg}
                  alt=""
                />
                <div className="guide_article_content">
                  <p className="guide_article_label">Educational guide</p>
                  <h1>{guide.title}</h1>
                  {guide.statusNote && (
                    <div className="guide_status_note">
                      <strong>Current-status note:</strong> {guide.statusNote}
                    </div>
                  )}
                  <p className="guide_article_intro">{guide.intro}</p>

                  {guide.sections.map((section) => (
                    <section className="guide_article_section" key={section.heading}>
                      <h2>{section.heading}</h2>
                      {section.paragraphs?.map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                      ))}
                      {section.bullets && (
                        <ul>
                          {section.bullets.map((bullet) => (
                            <li key={bullet}>{bullet}</li>
                          ))}
                        </ul>
                      )}
                      {section.table && (
                        <div className="guide_table_wrap">
                          <table className="guide_table">
                            <thead>
                              <tr>
                                {section.table.headers.map((header) => (
                                  <th key={header}>{header}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {section.table.rows.map((row) => (
                                <tr key={row[0]}>
                                  {row.map((cell) => (
                                    <td key={cell}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </section>
                  ))}

                  {guide.source && (
                    <div className="guide_source">
                      <strong>Official source:</strong>{" "}
                      <a
                        href={guide.source.url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {guide.source.label}
                      </a>
                    </div>
                  )}
                  <div className="guide_article_footer">
                    <Link to="/service">Back to all loan guides</Link>
                    <Link to="/contact">Ask a general question</Link>
                  </div>
                </div>
              </div>
            </article>

            <aside className="col-lg-3 guide_sidebar">
              <h3 className="service_detail_left_heading">Loan Guides</h3>
              {serviceData.map((item) => (
                <Link
                  className={
                    "guide_sidebar_link" +
                    (item.slug === guide.slug ? " active" : "")
                  }
                  to={"/service/" + item.slug}
                  key={item.slug}
                >
                  {item.title}
                </Link>
              ))}
              <div className="guide_sidebar_notice">
                <i className="fa-solid fa-circle-info" aria-hidden="true"></i>
                <p>
                  PyLoan provides educational information only. We do not
                  accept or process loan applications.
                </p>
              </div>
            </aside>
          </div>
        </div>
      </main>
    </>
  );
}

export default ServiceDetail;
